<template>
  <div class="menu">
    <span class="button-menu-back sprite-return" @click="$emit('backMenu')"/>
    <scroller class="scroller-menu" :maxWidth="950" :offset="20">
      <button-menu
        class="button-menu-format button-menu-format__selected"
        label="Personalisé"
        iconClass="format-item-personal"
        @click.native.prevent.stop="onPersonnalFormatClicked"
      />
      <button-format
        v-for="format in getFormatList"
        :key="format.label"
        :label="format.label"
        :iconClass="format.class"
        :network="format.network"
        :icon="format.icon"
        @click.native="onChangeFormat($event, format)"
      />
    </scroller>
  </div>
</template>
<script>
import ButtonFormat from '@/components/buttons/ButtonFormat'
import ButtonMenu from '@/components/buttons/ButtonMenu'
import Scroller from '@/components/scroller/Scroller'
import { EventBus, TEMPLATE_MODIFIED } from '@/model/EventBus'
import { mapActions, mapGetters } from 'vuex'
import menu from '../menu-default'
export default {
  name: 'FormatMenu',
  mixins: [menu],
  components: {
    ButtonMenu,
    ButtonFormat,
    Scroller
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {
      currentSelected: null
    }
  },
  props: {},
  computed: {
    ...mapGetters(['getFormatList'])
  },
  methods: {
    ...mapActions(['updateCurrentFormat']),
    onChangeFormat(event, item) {
      this.$nextTick(() => {
        const elem = document.querySelector('.button-menu-format__selected')
        if (elem) {
          elem.classList.remove('button-menu-format__selected')
        }
        event.target.classList.add('button-menu-format__selected')
      })
      const f = {
        format: item.formats[0].format,
        width: item.formats[0].width,
        height: item.formats[0].height,
        network: item.network,
        font: item.font,
        icon: item.icon,
        label: item.label
      }
      this.updateCurrentFormat(f)
      this.editor.changeFormat(f.width, f.height)
      EventBus.$emit(TEMPLATE_MODIFIED)
    },
    onPersonnalFormatClicked() {
      this.changeMenu('PersonnalFormat')
    }
  },
  watch: {}
}
</script>



// WEBPACK FOOTER //
// src/components/menu/format/FormatMenu.vue